// 注意：以下聯絡資訊為暫用資料，請替換成正式資訊後上線
const infoCards = [
  {
    icon: 'ri-phone-line',
    color: '#D4A373',
    title: '電話諮詢',
    value: '04-1234-5678',
    note: '週一至週五 09:00–18:00',
    placeholder: true,
  },
  {
    icon: 'ri-mail-line',
    color: '#5C5470',
    title: 'Email 信箱',
    value: 'info@insurancearchitect.com',
    note: '通常於 1–2 個工作天內回覆',
    placeholder: true,
  },
  {
    icon: 'ri-line-fill',
    color: '#FF8C69',
    title: 'LINE@',
    value: '@031gzncd',
    note: '加入後可直接留言諮詢',
    placeholder: false,
  },
  {
    icon: 'ri-map-pin-line',
    color: '#D4A373',
    title: '服務地區',
    value: '台灣全區',
    note: '提供線上視訊與電話諮詢服務',
    placeholder: false,
  },
];

export default function ContactInfo() {
  return (
    <section className="bg-white py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            CONTACT INFO
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            聯絡資訊
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {infoCards.map((card) => (
            <div
              key={card.title}
              className="bg-[#F8F5F0] rounded-2xl p-7 border border-transparent hover:border-[#D4A373]/30 transition-all duration-200"
              style={{ boxShadow: '0 2px 12px 0 rgba(92,84,112,0.05)' }}
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-5"
                style={{ backgroundColor: `${card.color}18` }}
              >
                <i className={`${card.icon} text-2xl`} style={{ color: card.color }}></i>
              </div>
              <p className="text-gray-500 mb-1" style={{ fontSize: '1rem' }}>{card.title}</p>
              <p className="font-semibold text-[#5C5470] mb-2" style={{ fontSize: '1.1875rem', lineHeight: '1.5' }}>
                {card.value}
              </p>
              <p className="text-gray-400" style={{ fontSize: '1rem', lineHeight: '1.6' }}>{card.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
